import type { ChangeEvent } from 'react';
import { LegalCheck } from '@cian/ui-kit';

import { MARKETING_AGREEMENT_URL, PERSONAL_DATA_URL, PRIVACY_POLICY_URL } from 'shared/constants/dealsForm';

import * as s from './DealsLegalCheck.css';

export interface IDealsLegalCheckProps {
  checked?: boolean;
  onCheckedChange?(event: ChangeEvent<HTMLInputElement>, value: boolean): void;
  inverted?: boolean;
  withMarketingAgreement?: boolean;
}

/**
 * Юридические согласия для форм заявки продукта "Циан Сделки"
 */
export const DealsLegalCheck = ({
  checked,
  onCheckedChange,
  inverted = false,
  withMarketingAgreement = false,
}: IDealsLegalCheckProps) => (
  <div className={inverted ? s['legal-check-wrapper'] : undefined}>
    <LegalCheck
      checked={checked}
      privacyPolicyUrl={PRIVACY_POLICY_URL}
      personalDataUrl={PERSONAL_DATA_URL}
      marketingAgreementUrl={withMarketingAgreement ? MARKETING_AGREEMENT_URL : undefined}
      onCheckedChange={onCheckedChange}
    />
  </div>
);
